import { useQueryClient } from '@tanstack/react-query'
import { duplicateConsignmentItem } from '../api/duplicateConsignmentItem'
import getConsignmentItemSuccessHandlers from './consignmentItemSuccessHandlers'

function useDuplicateConsignmentItem(consignmentId: number, houseConsignmentId: number) {
  const queryClient = useQueryClient()

  const { onCreateSuccess } = getConsignmentItemSuccessHandlers(queryClient, consignmentId, houseConsignmentId)

  const duplicate = async (id: number) => {
    const duplicated = await duplicateConsignmentItem(id)
    await onCreateSuccess(duplicated)
    return duplicated
  }

  return {
    duplicate,
  }
}

export default useDuplicateConsignmentItem
